import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ProfileComponent } from "../profile/profile.component";
import { SubscriptionComponent } from '../subscription/subscription.component';
import { HistoryComponent } from "../history/history.component";
import { HistoryEventService } from '../services/history.event.service';
import { AccountService } from '../services/account';
import { TopWidgetComponent } from "../topwidget/topwidget.component";

const MODULES: any[] = [
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  FormsModule,
  ReactiveFormsModule
];

@Component({
  selector: 'app-private',
  standalone: true,
  imports: [MODULES, ProfileComponent, SubscriptionComponent, HistoryComponent, TopWidgetComponent],
  templateUrl: './private.component.html',
  styleUrl: './private.component.css',
})
export class PrivateComponent {
  private accountService = inject(AccountService);
  public isDataLoaded: boolean = false;
  private changeDetectorRef = inject(ChangeDetectorRef);

  constructor(
    private historyEventService: HistoryEventService,
  ) {
    this.historyEventService.resetEvent();
    this.historyEventService.createEvent('account');
    this.accountService.checkExpireToken("Send event account").subscribe(res => {
      this.isDataLoaded = true;
      this.historyEventService.setEvent('account');
      this.changeDetectorRef.markForCheck();
    });
  }
}
